import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["description", "disabled", "id", "selectedValue", "onChange", "options", "title", "variant"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { Option, Select } from 'components/Select';
import FormField from 'components/FormField';
import { jsx as _jsx } from "react/jsx-runtime";
function SelectField(_ref) {
  var description = _ref.description,
    disabled = _ref.disabled,
    id = _ref.id,
    selectedValue = _ref.selectedValue,
    onChange = _ref.onChange,
    options = _ref.options,
    title = _ref.title,
    variant = _ref.variant,
    otherFormFieldProps = _objectWithoutProperties(_ref, _excluded);
  function selectOption(value) {
    onChange === null || onChange === void 0 || onChange(id, value, title);
  }
  var descriptionId = description ? "".concat(id, "-desc") : undefined;
  return /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
    id: id,
    as: "span",
    label: title
  }, otherFormFieldProps), {}, {
    children: /*#__PURE__*/_jsx(Select, {
      value: selectedValue,
      onChange: selectOption,
      size: "medium",
      labelledById: "".concat(id, "-label"),
      "aria-describedby": descriptionId,
      isDisabled: disabled,
      variant: variant,
      children: options.map(function (item) {
        return /*#__PURE__*/_jsx(Option, {
          value: item.value,
          children: item.title
        }, item.value);
      })
    })
  }));
}
export default SelectField;